const statuses = {
  Received: { text: 'Принят', color: 'secondary' },
  Forwarded: { text: 'Передан в API', color: 'success' },
  Duplicate: { text: 'Повтор', color: 'info' },
  Rejected: { text: 'Отклонён', color: 'warning' },
  Failed: { text: 'Ошибка разбора', color: 'error' },
  Exhausted: { text: 'Попытки исчерпаны', color: 'error' },
}

export const callbackStatus = value => statuses[value] || { text: value || '—', color: 'secondary' }

export const callbackStatusText = value => callbackStatus(value).text

export const callbackStatusColor = value => callbackStatus(value).color

export const troubledStatuses = ['Failed', 'Exhausted', 'Rejected']
